<template>
    <div class="agri-platform-container">
        <div class="top-title">
            <h2>芯棚到家小程序</h2>
        </div>
        <!-- 主体内容区域 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="11">
                <img :src="dashboardImg" alt="芯棚到家小程序" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="13">
                <div class="desc-card">
                    <p>作为芯棚智云数智农业管理系统的移动端延伸，小程序聚焦农业生产“移动化、轻量化”管理需求，整合设备监控、数据查看、远程控制、视频监控、告警提醒五大核心功能，让农户、农场管理者摆脱PC端束缚。
                    </p>
                    <p>无论身处何地，打开微信就能实时掌握棚区设备状态、土壤温湿度、水肥数据，远程操控灌溉、风机等设备，接收设备告警通知，实现“人不在棚区，生产不脱节”，让农业管理更高效、更省心。
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AgriPlatformPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/Mainsoftware/xpdj.png')

        }
    }
}
</script>
